import { createContext, useContext, useEffect } from 'react';
import type { SiteBrand } from './branding';
import { initializeBranding } from './branding-utils';

// Brand Context for route-based brand override
const BrandOverrideContext = createContext<SiteBrand | null>(null);

export const BrandProvider = ({
  brand,
  children,
}: {
  brand: SiteBrand;
  children: React.ReactNode;
}) => {
  useEffect(() => {
    initializeBranding(brand);
  }, [brand]);

  return <BrandOverrideContext.Provider value={brand}>{children}</BrandOverrideContext.Provider>;
};

export const useBrandOverride = (): SiteBrand | null => {
  return useContext(BrandOverrideContext);
};
